import angular from 'angular';
import proceedingsListComponent from './proceedings-list.component';
import proceedingsListService from './proceedings-list.service';
import proceedingsListConfig from './proceedings-list.config';

let proceedingsListModule = angular.module('app.proceedingsList',[])
  .component('proceedingsList', proceedingsListComponent)
  .service('proceedingsListService', proceedingsListService)
  .config(proceedingsListConfig);

export default proceedingsListModule;






/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/proceedings-list/proceedings-list.js
 **/